import axios, { AxiosResponse } from "axios"
import { EntityListResponseTransaction } from "cs.node.utils/csapi/provisioning"
import { checkResponseStatus } from "./Utils"

export const listTransactionByCorrelationUUID = async(correlationUUID: string, pageIndex?: number, pageSize?: number, sort?: string, shallow?: boolean) =>{
    try{
        const response:AxiosResponse<EntityListResponseTransaction,any> = await axios.get('api/tracking/transactions/list-by-correlation-uuid', {
            params: {correlationUUID, pageIndex, pageSize, sort, shallow}
        })
        return response.data 
    } catch(error: any) {
        checkResponseStatus(error)
        throw error
    }
}